import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Menu, Button, Avatar } from "ant-design-vue";

const Vue = createApp(App);

Vue.use(Menu).use(Button).use(Avatar);

Vue.use(store).use(router).mount("#app");
